export default __webpack_public_path__ + "static/homepage_surveys-d0924c0204f3f990bbd40d48b84262c6.mp4";